/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunEditCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('TimePayrollPayrunEditCtrl', ["dialog", "$filter", "$q", "$scope", "$state", "$stateParams", "TimePayrollAdjustment", "TimePayrollPayruns", "TimeStaff", "TimeClock", "title", "userinfo", function(dialog, $filter, $q, $scope, $state, $stateParams, TimePayrollAdjustment,
    TimePayrollPayruns, TimeStaff, TimeClock, title, userinfo) {
  $scope.frequencyOptions = [
    {value: 0, label: 'Weekly'},
    {value: 1, label: 'Fortnightly'},
    {value: 2, label: 'Monthly'}
  ];

  if ($stateParams.id) {
    $scope.loading = TimePayrollPayruns.get($stateParams.id);
    title.set('Pay Run Edit');
  } else {
    $scope.loading = TimePayrollPayruns.getNew(
      $stateParams.start,
      $stateParams.end,
      $stateParams.payment,
      $stateParams.frequency
    );
    title.set('Pay Run Create');
    $scope.createPayrun = true;
  }

  $scope.fullPayroll = userinfo.companyPreferenceGet('features.payroll') == '1';

  $scope.loading.then(function(payrun) {
    $scope.payrun = payrun;

    $scope.loading =
    $scope.loading = $q.all({
      staff: TimeStaff.getAllActive(payrun.datestampEnd),
      adjustments: TimePayrollAdjustment.getAllActive()
    });

    $scope.loading.then(function(result) {
      $scope.staff = result.staff;
      $scope.adjustments = result.adjustments;
      angular.forEach($scope.payrun.lines, function(payrunLine) {
        $scope.updateTotals(payrunLine);
      });
    });
  });

  var validate = function() {
    var invalidLine = false;
    angular.forEach($scope.payrun.lines, function(payrunLine) {
      if (invalidLine) {
        return;
      }

      angular.forEach(payrunLine.clockins, function(clockin) {
        if (invalidLine) {
          return;
        }

        if ($scope.isClockOutOfRange(clockin, payrunLine)) {
          invalidLine = payrunLine;
          $scope.editWages(payrunLine);
        }
      });
    });
    return invalidLine;
  };

  /**
   * Save changes to a payrun to the server
   */
  $scope.savePayrun = function() {
    if (validate()) {
      return;
    }

    if ($stateParams.id) {
      $scope.saving = TimePayrollPayruns.update($scope.payrun);
    } else {
      $scope.saving = TimePayrollPayruns.create($scope.payrun);
    }

    $scope.saving.then(function() {
      $state.go('Time.Payroll.PayrunOutstanding');
    });
  };

  /**
   * Save changes to a payrun to the server
   */
  $scope.reviewPayrun = function() {
    if (validate()) {
      return;
    }

    if ($stateParams.id) {
      $scope.reviewing = TimePayrollPayruns.update($scope.payrun);
    } else {
      $scope.reviewing = TimePayrollPayruns.create($scope.payrun);
    }

    $scope.reviewing.then(function(result) {
      var payrunId = $stateParams.id || result.id;
      $state.go('Time.Payroll.PayrunReview', {id: payrunId});
    });
  };

  /**
   * Populate the select box for adding new employees to the payrun. Return any staff that aren't
   * already on the payrun.
   */
  $scope.addEmployeeSelect = function() {
    if (!$scope.payrun) {
      return [];
    }

    var active = {};
    angular.forEach($scope.payrun.lines, function(payrunLine) {
      active[payrunLine.staffMemberId] = true;
    });

    var selection = [];
    angular.forEach($scope.staff, function(staffMember) {
      if (!active[staffMember.id]) {
        selection.push(staffMember);
      }
    });
    return $filter('orderBy')(selection, 'name');
  };

  /**
   * Add a new employee to the payrun
   */
  $scope.addEmployee = function(staffId) {
    $scope.adding = true;
    TimePayrollPayruns.getNewLine($scope.payrun.datestampStart, $scope.payrun.datestampEnd, staffId)
    .then(function(result) {
      $scope.adding = false;
      $scope.employeeToAdd = null;
      $scope.payrun.lines.push(result);
    }, function() {
      $scope.adding = false;
      $scope.employeeToAdd = null;
    });
  };

  /**
   * Delete an employee from the payrun. If that employee has shifts, show a confirm dialog before removing.
   */
  $scope.deleteEmployee = function(line) {
    var confrimPromise;
    if (line.clockins.length > 0) {
      confrimPromise = dialog.confirm('This staff member has worked during this period. Are you sure you want to remove this staff member?');
    } else {
      confrimPromise = $q.when(true);
    }

    confrimPromise.then(function(confirmed) {
      if (confirmed) {
        angular.forEach($scope.payrun.lines, function(payrunLine, index) {
          if (payrunLine.staffMemberId == line.staffMemberId) {
            $scope.payrun.lines.splice(index, 1);
          }
        });
      }
    });
  };

  $scope.deletePayrun = function() {
    $scope.deleting = TimePayrollPayruns.remove($scope.payrun);
    $scope.deleting.then(function() {
      $state.go('Time.Payroll.PayrunOutstanding');
    });
  };

  $scope.editWages = function(payrunLine) {
    $scope.payrunLine = payrunLine;
    $scope.staffMember = $filter('filter')($scope.staff, {id: payrunLine.staffMemberId})[0];

    var salaryPaytype = $filter('filter')(payrunLine.paytypes, {paytypeAbbrev: 'SALARY'});
    if (salaryPaytype.length === 0) {
      dialog.open({
        templateUrl: 'modules/time/payroll/payrun/editwages.tpl.html',
        controller: 'TimePayrollPayrunEditwagesCtrl',
        scope: $scope,
        size: 'lg'
      });
    } else {
      dialog.open({
        templateUrl: 'modules/time/payroll/payrun/showsalary.tpl.html',
        scope: $scope
      });
    }
  };

  $scope.editLeave = function(payrunLine) {
    $scope.payrunLine = payrunLine;
    $scope.staffMember = $filter('filter')($scope.staff, {id: payrunLine.staffMemberId})[0];

    dialog.open({
      templateUrl: 'modules/time/payroll/payrun/editleave.tpl.html',
      controller: 'TimePayrollPayrunEditleaveCtrl',
      scope: $scope,
      size: 'lg'
    });
  };

  $scope.editAllowances = function(payrunLine) {
    $scope.payrunLine = payrunLine;
    $scope.staffMember = $filter('filter')($scope.staff, {id: payrunLine.staffMemberId})[0];

    dialog.open({
      templateUrl: 'modules/time/payroll/payrun/editallowances.tpl.html',
      controller: 'TimePayrollPayrunEditallowancesCtrl',
      scope: $scope,
      size: 'lg'
    });
  };

  $scope.editSpecial = function(payrunLine) {
    $scope.payrunLine = payrunLine;
    $scope.staffMember = $filter('filter')($scope.staff, {id: payrunLine.staffMemberId})[0];

    dialog.open({
      templateUrl: 'modules/time/payroll/payrun/editspecial.tpl.html',
      controller: 'TimePayrollPayrunEditspecialCtrl',
      scope: $scope,
      size: 'lg'
    });
  };

  /**
  * Update the total* fields for a payrun line
  *
  * @param {Object} payrunLine - The payrun line model to count and update the fields for
  */
  $scope.updateTotals = function(payrunLine) {

    var salaryPaytype = $filter('filter')(payrunLine.paytypes, {paytypeAbbrev: 'SALARY'});
    if (salaryPaytype.length === 0) {
      var totalHours = 0;
      var totalCost = 0;

      angular.forEach(payrunLine.clockins, function(clock) {
        clock.length = TimeClock.getClockinLength(clock.clockoutTime, clock.clockinTime);
        clock.cost = clock.length * clock.adjustedHourlyRate;

        var includedClockinsMatch = $filter('filter')(payrunLine.includedClockins, {clockinId: clock.id});
        if (includedClockinsMatch.length !== 0) {
          totalHours += clock.length;
          totalCost += clock.cost;
        }
      });

      // Remove all existing wage paytype lines.
      payrunLine.paytypes = $filter('filter')(payrunLine.paytypes, function(paytypeLine) {
        return paytypeLine.paytypeModule !== 0;
      });

      // Add a wage line with the updated total
      payrunLine.paytypes.push({
        paytypeAbbrev: 'WAGES',
        paytypeModule: 0,
        quantity: totalHours,
        rate: (totalHours !== 0) ? totalCost / totalHours : 0
      });

      var hoursDependentAllowances = $filter('filter')(payrunLine.paytypes, {paytypeModule: 1, paytypeDefaultQuantity: 1});
      angular.forEach(hoursDependentAllowances, function(payrunLinePaytype) {
        payrunLinePaytype.quantity = totalHours;
      });
    }

    payrunLine.totalWages = 0;
    payrunLine.totalAllowance = 0;
    payrunLine.totalLeave = 0;
    payrunLine.totalSpecial = 0;
    payrunLine.totalGross = 0;
    angular.forEach(payrunLine.paytypes, function(payrunLinePaytype) {
      var cost = payrunLinePaytype.rate * payrunLinePaytype.quantity;
      switch (payrunLinePaytype.paytypeModule) {
        case 0:
          payrunLine.totalWages += cost;
          payrunLine.totalGross += cost;
        break;
        case 1:
          if (payrunLinePaytype.paytypeDefaultQuantity === 0) {
            cost = payrunLinePaytype.rate;
          }
          payrunLine.totalAllowance += cost;
          if (payrunLinePaytype.paytypeIsTaxable) {
            payrunLine.totalGross += cost;
          }
        break;
        case 2:
          payrunLine.totalLeave += cost;
          payrunLine.totalGross += cost;
        break;
        case 3:
          payrunLine.totalSpecial += cost;
          payrunLine.totalGross += cost;
        break;
      }
    });

    payrunLine.totalPay = payrunLine.totalWages + payrunLine.totalAllowance;
  };

  $scope.updatePayrunDates = function() {
    var loadingPromise = $q.defer();
    $scope.loading = loadingPromise.promise;

    // we need to recreate the payrun in order to recalculate the wages editspecial
    // so delete the existing one, then resubmit it
    TimePayrollPayruns.remove($scope.payrun).then(function() {
      TimePayrollPayruns.getNew(
        $scope.payrun.datestampStart,
        $scope.payrun.datestampEnd,
        $scope.payrun.datestampPayment,
        $scope.payrun.frequency
      ).then(function(result) {
        if ($stateParams.id) {
          result.id = $stateParams.id;
        }

        $scope.payrun = result;
        loadingPromise.resolve();
      });
    });
  };

  $scope.isClockOutOfRange = function(clock, payrunLine) {
    var includedInPayrun = $filter('filter')(payrunLine.includedClockins, {clockinId: clock.id});
    return includedInPayrun.length && (moment(clock.clockinTime).isBefore(payrunLine.datestampStart) ||
        moment(clock.clockoutTime).isAfter($scope.payrun.datestampEnd));
  };
}]);
